import React, { useEffect, useState } from "react";
import { servicesImages, toastIamges } from "../../assets/img/allImages";
import useToast from "./useToast";

const toastConfig = {
  error: {
    cancelIcon: toastIamges.cancelError,
    specificStyles: "bg-[#FFECEB] border-[#FEC8C7]",
    icon: toastIamges.errorIcon,
  },
  success: {
    cancelIcon: toastIamges.cancelSuccess,
    specificStyles: "bg-[#EDF8F1] border-[#C9E8D5]",
    icon: toastIamges.successIcon,
  },
  warning: {
    cancelIcon: toastIamges.cancelWarning,
    specificStyles: "bg-[#EDF8F1] border-[#F6E5CC]",
    icon: toastIamges.warnigIcon,
  },
  hint: {
    cancelIcon: toastIamges.cancelHint,
    specificStyles: "bg-[#E6E7F9] border-[#ACAFEC]",
    miniTextStyle: "text-[#868686]",
    icon: servicesImages.police.hintIcon,
  },
};

const showToastContainer = () => {
  const toastContainer = document.getElementById("toast_container");
  toastContainer.style.right = "20px";
};

const hideToastContainer = () => {
  const toastContainer = document.getElementById("toast_container");
  toastContainer.style.right = "-100%";
};

const ToastContainer = () => {
  const { toastData, toastType } = useToast();

  const [toastSettings, setToastSettings] = useState(() => ({
    canelIcon: "",
    icon: toastIamges.errorIcon,
    cancelIcon: toastIamges.cancelError,
    title: "",
    description: "",
    specificStyles: "bg-[#FFECEB] border-[#FEC8C7]",
  }));

  useEffect(() => {
    showToastContainer();
    const toastCoinfig = toastConfig[toastType];
    const { title, description } = toastData;
    setToastSettings({
      ...toastCoinfig,
      title,
      description,
    });

    setTimeout(() => {
      hideToastContainer();
    }, 3000);
  }, [toastData]);

  return <ToastRenderer {...toastSettings} />;
};

export default ToastContainer;

const ToastRenderer = ({
  description,
  title,
  icon,
  cancelIcon,
  specificStyles,
  miniTextStyle,
}) => (
  <div
    id="toast_container"
    className="absolute top-[40px] toast_element w-[90%] md:w-[500px] rounded-[24px] md:rounded-[34px]"
  >
    {title && (
      <div className="w-full h-full relative">
        <div
          className={`w-full px-5  absolute top-0 z-[600000000000001] py-[15px] right-0 rounded-[24px] ${
            title ? "border-[1px]" : " border-[0]"
          } flex flex-col items-start justify-start ${specificStyles}`}
        >
          <div className="flex items-center justify-between w-full">
            <img
              className="w-[4.5%] md:w-[16px] aspect-square"
              src={icon}
              alt="toast icon"
            />
            <p
              id="toast_msg"
              className="w-full text-[14px] text-textPrimary mr-[14px]"
            >
              {title}
            </p>
            <button onClick={() => hideToastContainer()}>
              <img
                className="w-[4vw] z-[2000000000000] md:w-[16px] aspect-square"
                src={cancelIcon}
                alt="toast icon"
              />
            </button>
          </div>
          <h5 className={`text-[10px] mr-8 text-start ${miniTextStyle}`}>
            {description}
          </h5>
        </div>
      </div>
    )}
  </div>
);
